import { Input, makeStyles, Select } from "@fluentui/react-components";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { useEffect, useState } from "react";
import { IWorkspaceFilterItemProps } from "./workspace-filter-item.props";

const layoutStyles = makeStyles({
    mainWrapper: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '1em',
        '> *': {
            marginRight: '1em'
        }
    }
});

export default function WorkspaceFilterItem(props: IWorkspaceFilterItemProps) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();

    const [property, setProperty] = useState<string | undefined>(props.filter?.property);
    const [operator, setOperator] = useState<number | undefined>(props.filter?.operator);
    const [value, setValue] = useState<string | undefined>(props.filter?.value);

    useEffect(() => {
        if (property && operator && value)
            props.onChange({ property: property, operator: operator, value: value });
        else
            props.onChange(undefined);
    }, [property, operator, value]);

    return (
        <div className={styles.mainWrapper}>
            <Select
                appearance="underline"
                defaultValue=""
                value={property || ""}
                onChange={(e, v) => { setProperty(v.value) }}>
                <option value="" disabled hidden></option>
                <option value="ownerUpn">{t('ppaOwnerUpn')}</option>
                <option value="title">{t('title')}</option>
                <option value="url">{t('url')}</option>
            </Select>
            <Select
                appearance="underline"
                defaultValue=""
                value={operator || ""}
                onChange={(e, v) => { setOperator(Number(v.value)) }}>
                <option value="" disabled hidden></option>
                <option value="1">{t('operatorContains')}</option>
                <option value="2">{t('operatorEndsWith')}</option>
                <option value="3">{t('operatorEquals')}</option>
                <option value="4">{t('operatorStartsWith')}</option>
            </Select>
            <Input
                appearance="underline"
                value={value || ""}
                onChange={(e, v) => { setValue(v.value) }} />
        </div>
    );
}